import React from 'react'
import Calendar from '~/components/Calendar'
import './styles.css'

class SmallCalendar extends React.Component {
 render(){
  return(
   <div className="small-calendar">
    <Calendar type={'All Events'} mobile={true}/>
   </div> 
  )
 }

}
export default SmallCalendar